import { useDispatch, useSelector, TypedUseSelectorHook } from 'react-redux';
import { configureStore } from '@reduxjs/toolkit';
import { persistStore, persistReducer, PURGE, FLUSH, PAUSE } from 'redux-persist';
import storage from 'redux-persist/lib/storage';
import rootReducer from './reducer'; 

const persistConfig = {
    key: 'root',
    storage,
};

// Persist the root reducer
const persistedReducer = persistReducer(persistConfig, rootReducer);

// Create the Redux store
const store = configureStore({
    reducer: persistedReducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
            thunk: true,
        }),
});

// Create the persistor
const persistor = persistStore(store);


const purgePersistor = async () => {
    await persistor.pause();  
    await persistor.purge();  
    await persistor.flush();  
};

// Types
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;

// Typed hooks
export const useAppDispatch: () => AppDispatch = () => useDispatch<AppDispatch>();
export const useAppSelector: TypedUseSelectorHook<RootState> = useSelector;

export { store, persistor, purgePersistor };
